import React, { Component } from "react";
import Modal from "react-modal";
import { connect } from "react-redux";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import { userActions } from "../../_actions";
import { userConstants } from "../../_constants";
import "../../assets/css/EduAdmin.css";
import { Banner, Item, List } from "../../_components/ListSnjob";
import { BtnRound } from "../../_components/BtnRound";
import { ModalSnjob } from "../../_components/ModalSnjob";

Modal.setAppElement("#root");

class EduAdmin_ extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isEditing: false,
      activeCourse: 0,
      status: "active",
      addModal: false,
      courses: [],
      courseTitle: "",
      courseTypeValue: null,
      courseTypeOptions: [
        { id: 0, name: "اختیاری" },
        { id: 1, name: "عمومی" },
        { id: 2, name: "الزامی" },
      ],
      jobGroupValue: null,
      jobGroupOptions: [],
      domainValue: null,
      domainOptions: [
        { id: 0, name: "توانمند سازی" },
        { id: 1, name: "فنی مهندسی" },
        { id: 2, name: "تاسیسات" },
        { id: 3, name: "سایر" },
      ],
    };
  }

  componentDidMount = () => {
    this.getCourses();
    this.getJobGroups();
  };

  getCourses = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/courses`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({
          courses: res.data,
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  getJobGroups = () => {
    this.props
      .dispatch(
        userActions.API(
          "get",
          `v1/sub_admin/hospital/job_groups`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({
          jobGroupOptions: res.data.map(({ id, name }) => ({
            id,
            name,
          })),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  postCourses = () => {
    const { getCourses } = this;
    const { courseTitle, courseTypeValue, jobGroupValue, domainValue } =
      this.state;
    const data = {
      title: courseTitle,
      course_type: courseTypeValue.id,
      jobs_groups: jobGroupValue.map((val) => val.id),
      case_study: domainValue.map((val) => val.id),
    };

    this.props
      .dispatch(
        userActions.API(
          "post",
          `v1/sub_admin/hospital/courses`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then(() => {
        this.setState({
          status: "active",
          courseTitle: "",
          courseTypeValue: {},
          jobGroupValue: null,
          domainValue: null,
        });
        getCourses();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  putCourses = () => {
    const { getCourses } = this;
    const {
      courseTitle,
      courseTypeValue,
      jobGroupValue,
      activeCourse,
      courses,
      status,
      domainValue,
    } = this.state;
    const data = {
      id: courses[activeCourse].id,
      title: courseTitle,
      course_type: courseTypeValue.id,
      jobs_groups: jobGroupValue.map((val) => val.id),
      case_study: domainValue.map((val) => val.id),
      status: status,
    };

    this.props
      .dispatch(
        userActions.API(
          "put",
          `v1/sub_admin/hospital/courses`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then((res) => {
        this.setState({
          activeCourse: 0,
          isEditing: false,
          addModal: false,
          status: "active",
          courseTitle: "",
          courseTypeValue: {},
          jobGroupValue: null,
          domainValue: null,
        });
        getCourses();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  putStatus = (id) => {
    const { courses } = this.state;
    const nextStatus =
      courses.find((obj) => obj.id === id).status === "active"
        ? "deactive"
        : "active";
    const data = {
      id: id,
      status: nextStatus,
    };

    this.props
      .dispatch(
        userActions.API(
          "put",
          `v1/sub_admin/hospital/courses`,
          data,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then(() => {
        this.setState({
          activeCourse: id,
          courses: this.state.courses.map((obj) => {
            if (obj.id === id) {
              return {
                ...obj,
                status: nextStatus,
              };
            }
            return obj;
          }),
        });
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  delCourses = (id) => {
    const { getCourses } = this;

    this.props
      .dispatch(
        userActions.API(
          "delete",
          `v1/sub_admin/hospital/courses/${id}`,
          null,
          true,
          false,
          JSON.parse(localStorage.getItem("tokenAdmin"))
        )
      )
      .then(() => {
        this.setState({
          status: "active",
          courseTitle: "",
          courseTypeValue: {},
          jobGroupValue: null,
          domainValue: null,
        });
        getCourses();
      })
      .catch(() => userActions.failure(userConstants.ERRORS["serverError"]));
  };

  handleDelete = (id) => {
    this.props
      .dispatch(userActions.question("حذف", "آیا از حذف کردن مطمئن هستید؟"))
      .then((r) => {
        if (r.value) {
          this.delCourses(id);
        }
      });
  };

  render() {
    const { putCourses, postCourses, putStatus, handleDelete } = this;
    const {
      addModal,
      courseTitle,
      courseTypeOptions,
      jobGroupOptions,
      courseTypeValue,
      jobGroupValue,
      courses,
      isEditing,
      domainValue,
      domainOptions,
    } = this.state;

    const emptyTitle = "لطفا عنوان را وارد کنید.";
    const emptyCourseType = "لطفا نوع دوره را انتخاب کنید.";
    const emptyJobGroup = "لطفا گروه شغلی را انتخاب کنید.";
    const emptyDomainValue = "لطفا حیطه دوره آموزشی خود را انتخاب کنید.";

    const onPost = () => {
      if (courseTitle.length === 0) {
        return userActions.failure(emptyTitle);
      } else if (
        courseTypeValue === null ||
        !courseTypeValue.hasOwnProperty("name")
      ) {
        return userActions.failure(emptyCourseType);
      } else if (jobGroupValue === null || jobGroupValue.length === 0) {
        return userActions.failure(emptyJobGroup);
      } else if (domainValue === null || domainValue.length === 0) {
        return userActions.failure(emptyDomainValue);
      } else if (isEditing) {
        putCourses();
      } else if (!isEditing) {
        this.setState({ addModal: false }, postCourses);
      }
    };

    return (
      <>
        <div className="row EduAdmin">
          <div className="col-lg-11 col-md-12 m-auto">
            <List className="transparent-scroll container-fluid px-0 py-4">
              <ul
                className="list position-relative w-100 m-0 p-2"
                style={{
                  boxShadow: "none",
                }}
              >
                <Banner
                  grid="1fr 2fr 4fr 6fr 4fr 2fr 2fr"
                  style={{ zIndex: 1 }}
                  key={0}
                >
                  <div
                    className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                    style={{ fontSize: "12.6px" }}
                  >
                    ردیف
                  </div>
                  <div
                    className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                    style={{ fontSize: "12.6px" }}
                  >
                    نوع
                  </div>
                  <div
                    className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                    style={{ fontSize: "12.6px" }}
                  >
                    گروه شغلی
                  </div>
                  <div
                    className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                    style={{ fontSize: "12.6px" }}
                  >
                    نیاز آموزشی
                  </div>
                  <div
                    className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                    style={{ fontSize: "12.6px" }}
                  >
                    حیطه
                  </div>
                  <div
                    className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                    style={{ fontSize: "12.6px" }}
                  >
                    وضعیت
                  </div>
                  <div
                    className="w-100 h-100 d-flex justify-content-center align-items-center text-light font-weight-bold"
                    style={{ fontSize: "12.6px" }}
                  >
                    عملیات
                  </div>
                </Banner>
                {courses.map(
                  (
                    {
                      course_type,
                      jobs_groups,
                      jobs_groups_names,
                      title,
                      case_study,
                      status,
                      id,
                    },
                    i
                  ) => {
                    const courseTypeName = courseTypeOptions.find(
                      (obj) => obj.id === +course_type
                    ).name;
                    const jobsGroupsNames =
                      jobs_groups_names === undefined
                        ? "xxxx"
                        : jobs_groups_names.join("، ");
                    const domainText =
                      case_study.length !== 0
                        ? case_study
                            .map((id) => {
                              const temp = domainOptions.find(
                                (opt) => opt.id === id
                              );
                              return temp !== undefined ? temp.name : "-";
                            })
                            .join(", ")
                        : "-";

                    return (
                      <Item grid="1fr 2fr 4fr 6fr 4fr 2fr 2fr" key={i + 1}>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <p className="itemComp__text text-center text-primary m-0">
                            {i + 1}
                          </p>
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <p
                            className={`itemComp__text m-0 course_type--${course_type}`}
                          >
                            {courseTypeName}
                          </p>
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          {jobs_groups.length === jobGroupOptions.length ? (
                            <>
                              <BtnRound
                                data_tip={`کل سازمان: ${jobsGroupsNames}`}
                                className="hospital-logo"
                                onClick={() => ""}
                              />
                              <ReactTooltip type="dark" />
                            </>
                          ) : (
                            <p
                              className="itemComp__text m-0"
                              data-tip={jobsGroupsNames}
                            >
                              {jobsGroupsNames.length > 35
                                ? jobsGroupsNames.slice(0, 25) + "..."
                                : jobsGroupsNames}
                            </p>
                          )}
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <p className="itemComp__text m-0">{title}</p>
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <p className="itemComp__text m-0">{domainText}</p>
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <BtnRound
                            className={`${
                              status === "active" ? "success" : "error"
                            }-logo`}
                            onClick={() => {
                              putStatus(id);
                            }}
                          />
                        </div>
                        <div
                          className="d-flex justify-content-center align-items-center h-100 w-100"
                          style={{ gap: "10px" }}
                        >
                          <BtnRound
                            // data_tip="ویرایش"
                            className="edit-logo"
                            onClick={() => {
                              const activeCourseObject = this.state.courses[i];
                              const domainValue =
                                activeCourseObject.case_study.map((id) =>
                                  this.state.domainOptions.find(
                                    (opt) => opt.id === id
                                  )
                                );
                              const courseTypeName =
                                this.state.courseTypeOptions.find(
                                  (obj) =>
                                    obj.id === +activeCourseObject.course_type
                                );
                              const jobsGroupsObjs =
                                activeCourseObject.jobs_groups.map((id) =>
                                  this.state.jobGroupOptions.find(
                                    (obj) => obj.id === id
                                  )
                                );

                              this.setState({
                                activeCourse: i,
                                isEditing: true,
                                addModal: true,

                                courseTitle: activeCourseObject.title,
                                courseTypeValue: courseTypeName,
                                status: activeCourseObject.status,
                                jobGroupValue: jobsGroupsObjs,
                                domainValue,
                              });
                            }}
                          />
                          <BtnRound
                            // data_tip="حذف"
                            className="delete-logo"
                            onClick={() => handleDelete(id)}
                          />
                        </div>
                        <ReactTooltip type="dark" />
                      </Item>
                    );
                  }
                )}
                <BtnRound
                  className="mt-3 mx-auto add-logo"
                  style={{ borderRadius: "50%" }}
                  onClick={() => this.setState({ addModal: true })}
                />
              </ul>
            </List>
          </div>
        </div>
        <ModalSnjob
          title="ایجاد درصد پیشرفت جدید"
          className="EduAdmin eduadmin_container"
          isOpen={addModal}
          onClose={() => this.setState({ addModal: false })}
        >
          <div className="w-100 px-4">
            <p className="iran-sans_Bold pr-3 text-right mt-3 text_style w-100">
              عنوان دوره
            </p>
            <Input
              value={courseTitle}
              onChange={(e) => this.setState({ courseTitle: e.target.value })}
              placeholder="عنوان دوره را انتخاب کنید"
            />
          </div>
          <div className="w-100 px-4">
            <p className="iran-sans_Bold pr-3 text-right mt-3 text_style w-100">
              نوع دوره
            </p>
            <SelectType
              value={courseTypeValue}
              options={courseTypeOptions}
              isMulti={false}
              onChange={(e) => {
                if (e.id === 1) {
                  this.setState({
                    courseTypeValue: e,
                    jobGroupValue: jobGroupOptions,
                  });
                } else {
                  this.setState({ courseTypeValue: e });
                }
              }}
              placeholder="نوع دوره را انتخاب کنید"
            />
          </div>

          <div className="w-100 px-4">
            <p className="iran-sans_Bold pr-3 text-right mt-3 text_style w-100">
              عنوان دوره
            </p>
            <Input
              value={courseTitle}
              onChange={(e) => this.setState({ courseTitle: e.target.value })}
              placeholder="عنوان دوره را انتخاب کنید"
            />
          </div>

          <div className="w-100 px-4">
            <p className="iran-sans_Bold pr-3 text-right mt-3 text_style w-100">
              گروه شغلی (گروه هدف)
            </p>
            <SelectType
              value={jobGroupValue}
              options={jobGroupOptions}
              isMulti={true}
              onChange={(e) => this.setState({ jobGroupValue: e })}
              placeholder="گروه شغلی که می توانند این دوره را ببینند انتخاب کنید"
            />
          </div>

          <div className="w-100 px-4">
            <p className="iran-sans_Bold pr-3 text-right mt-3 text_style w-100">
              حیطه
            </p>
            <SelectType
              value={domainValue}
              options={domainOptions}
              isMulti={true}
              onChange={(e) => this.setState({ domainValue: e })}
              placeholder="دوره آموزشی در کدام یک از حیطه های انتخابی می باشد."
            />
          </div>
          <div className=" w-auto text-center mt-3">
            <button
              onClick={onPost}
              class="btn  mx-2 btn-primary mt-3 rounded-pill iran-sans_Bold p-2 btn_eduAdmin "
            >
              ثبت
            </button>
            <button
              className="btn  mx-2 btn mt-3 rounded-pill iran-sans_Bold p-2 btn_empty"
              onClick={() => {
                if (isEditing) {
                  this.setState({
                    activeCourse: 0,
                    isEditing: false,
                    addModal: false,
                    status: "active",
                    courseTitle: "",
                    courseTypeValue: {},
                    jobGroupValue: null,
                    domainValue: null,
                  });
                } else {
                  this.setState({
                    addModal: false,
                    status: "active",
                    courseTitle: "",
                    courseTypeValue: {},
                    jobGroupValue: null,
                    domainValue: null,
                  });
                }
              }}
            >
              بازگشت
            </button>
          </div>
        </ModalSnjob>
      </>
    );
  }
}

class Input extends Component {
  render() {
    const {
      value = undefined,
      onChange = () => "",
      placeholder,
      style = {},
      type = "text",
    } = this.props;
    return (
      <input
        name="name"
        type={type}
        className="border-0 shadow-smm form-control"
        aria-label="Full Name"
        value={value}
        onChange={onChange}
        style={{ borderRadius: "12px", height: "50px", ...style }}
        placeholder={placeholder}
      />
    );
  }
}

class SelectType extends Component {
  render() {
    const {
      value,
      onChange,
      options,
      placeholder,
      height = "50px",
      className,
      isMulti = false,
    } = this.props;
    const selectStyle = {
      container: (baseStyles) => ({
        ...baseStyles,
        height,
        borderRadius: "12px",
      }),
      control: (baseStyles) => ({
        ...baseStyles,
        // padding: "6px 10px 6px 5px",
        height: "100%",
        color: "#104c81",
        // border: "1px solid #104c81",
        border: "none",
        borderRadius: "12px",
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        zIndex: "999",
        textAlign: "right",
      }),
    };
    const multiSelectStyle = {
      container: (baseStyles) => ({
        ...baseStyles,
        height: "auto",
        minHeight: height,
        borderRadius: "12px",
      }),
      control: (baseStyles) => ({
        ...baseStyles,
        // padding: "6px 10px 6px 5px",
        height: "100%",
        minHeight: height,
        color: "#104c81",
        // border: "1px solid #104c81",
        border: "none",
        borderRadius: "12px",
      }),
      menu: (baseStyles) => ({
        ...baseStyles,
        zIndex: "999",
        textAlign: "right",
      }),
    };

    return (
      <>
        {isMulti ? (
          <Select
            className={`shadow-smm ${className}`}
            isMulti
            styles={multiSelectStyle}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
          />
        ) : (
          <Select
            className={`shadow-smm ${className}`}
            styles={selectStyle}
            value={value}
            onChange={onChange}
            options={options}
            placeholder={placeholder}
            getOptionLabel={(opt) => opt.name}
            getOptionValue={(opt) => opt.id}
          />
        )}
      </>
    );
  }
}

const EduAdmin = connect((state) => ({
  globalStorage: state.globalStorage,
}))(EduAdmin_);

export { EduAdmin };
